import logo from '../../logo.svg';
import { useState } from "react";
import { useAuth } from "../../hooks/useAuth.js";

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const { login } = useAuth();
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
    const user = await login({ email, password });
    if (!user) {
      setErrorMessage("Email o contraseña son inválidos");
    }
  };

  return (
    <>
      <div className="flex min-h-full flex-1 items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-sm space-y-10">
          <div>
            <img
              className="mx-auto h-16 w-auto"
              src={logo}
              alt="RÖEN"
            />
            <h2 className="mt-4 text-center text-4xl font-bold leading-9 tracking-tight text-gray-900">
              Iniciar sesión
            </h2>

            <div className="pt-3 flex items-center justify-center">
              <div className="flex items-center">
                <p className="text-sm leading-6 text-gray-500">
                  ¿Aún no tienes una cuenta? <a href="/signup" className="font-semibold text-indigo-600 hover:text-indigo-500">Regístrate</a>
                </p>
              </div>
            </div>
          </div>

          <form className="space-y-6" onSubmit={handleLogin}>
            <div className="relative -space-y-px rounded-md shadow-sm">
              <div className="pointer-events-none absolute inset-0 z-10 rounded-md ring-1 ring-inset ring-gray-300" />
              <div>
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  id="email"
                  name="email"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={
                    errorMessage
                      ? "relative block w-full rounded-t-md border-1 py-1.5 text-gray-900 ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                      : "relative block w-full rounded-t-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  }
                  placeholder="Email"
                />
              </div>

              <div>
                <label htmlFor="password" className="sr-only">
                  Contraseña
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={
                    errorMessage
                      ? "block w-full rounded-b-md border-1 py-1.5 text-gray-900 ring-1 ring-inset ring-rose-500 placeholder:text-rose-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6"
                      : "block w-full rounded-b-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-100 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  }
                  placeholder="Contraseña"
                />
              </div>
            </div>

            {errorMessage && <div>
              <p className="-my-3 text-left text-sm leading-6 text-rose-600">
                {errorMessage}
              </p>
            </div>}

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Iniciar sesión
              </button>
            </div>

            <div className="flex items-center justify-center">
              <div className="flex items-center">
                <p className="-py-5 block text-sm leading-6 text-gray-500">
                  ¿Olvidaste o perdiste tu contraseña? <a href="/recover/password/" className="font-semibold text-indigo-600 hover:text-indigo-500">Recupérala</a>
                </p>
              </div>
            </div>

            <div className="relative mt-10">
              <div aria-hidden="true" className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200" />
              </div>
              <div className="relative flex justify-center text-sm font-medium leading-6">
                <span className="bg-white px-6 text-gray-900"></span>
              </div>
            </div>

            <div className="flex items-center justify-center">
              <div className="flex items-center">
                <p className="-py-5 block text-xs leading-6 text-gray-500">
                  <a href="https://files.roenpro.com/aviso_de_privacidad_terminos_y_condiciones_roen.pdf" target='_blank' rel='noreferrer'>Aviso de Privacidad | Términos y condiciones</a>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
